import React, { Component } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    Typography
} from '@mui/material';
import { AppDataContext } from '../../context/Context';
import i18n from '../../i18';
import { GradientEditor } from '../../components/gradient-utils/GradientEditor';
import { ColorPicker } from '../../components/gradient-utils/ColorPicker';
// Theme = {
//   gradientColorsPrivate: [Color, Color],
//   gradientColorsShop: [Color, Color],
//   gradientColorsAction: [Color, Color],
//   colorShop: Color,
//   colorPrivate: Color,
//   colorAction: Color
// }
// Color = { A: number, R: number, G: number, B: number }
//

class ThemeEditorDialog extends Component {
    onClose = () => {};
    onSave = () => {};
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: props.dialogOpen || false,
            ...props.initialValue,
            activeStep: 0
        };

        this.onClose = props.onClose;
        this.onSave = props.onSave;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                ...props.initialValue,
                activeStep: 0
            };
        }
        return null;
    }

    static contextType = AppDataContext;

    handleNextStep = () => {
        this.setState({ activeStep: this.state.activeStep + 1 });
    };
    handlePrevStep = () => {
        this.setState({ activeStep: this.state.activeStep - 1 });
    };

    handleClose = () => {
        this.setState({ dialogOpen: false });
        this.onClose();
    };

    handleSave = () => {
        const theme = {
            gradientColorsPrivate: this.state.gradientColorsPrivate,
            gradientColorsShop: this.state.gradientColorsShop,
            gradientColorsAction: this.state.gradientColorsAction,
            colorShop: this.state.colorShop,
            colorPrivate: this.state.colorPrivate,
            colorAction: this.state.colorAction
        };
        this.onSave(JSON.stringify(theme));
        this.handleClose();
    };

    render() {
        const {
            activeStep,
            gradientColorsPrivate,
            gradientColorsShop,
            gradientColorsAction,
            colorPrivate,
            colorShop,
            colorAction
        } = this.state;
        return (
            <Dialog open={this.state.dialogOpen} onClose={this.handleClose}>
                <DialogTitle>{i18n.t('themeEditor.title')}</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column">
                        {activeStep === 0 && (
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">
                                    {i18n.t(
                                        'themeEditor.privateGradientsTitle'
                                    )}
                                </Typography>

                                <GradientEditor
                                    colorStops={gradientColorsPrivate}
                                    onChange={(colorStops) =>
                                        this.setState({
                                            gradientColorsPrivate: colorStops
                                        })
                                    }
                                />

                                <Typography variant="subtitle1">
                                    {i18n.t('themeEditor.chooseColorPrivate')}
                                </Typography>

                                <ColorPicker
                                    color={colorPrivate}
                                    onChange={(color) =>
                                        this.setState({ colorPrivate: color })
                                    }
                                />
                            </Stack>
                        )}

                        {activeStep === 1 && (
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">
                                    {i18n.t('themeEditor.shopGradientsTitle')}
                                </Typography>
                                <GradientEditor
                                    colorStops={gradientColorsShop}
                                    onChange={(colorStops) =>
                                        this.setState({
                                            gradientColorsShop: colorStops
                                        })
                                    }
                                />

                                <Typography variant="subtitle1">
                                    {i18n.t('themeEditor.chooseColorShop')}
                                </Typography>

                                <ColorPicker
                                    color={colorShop}
                                    onChange={(color) =>
                                        this.setState({ colorShop: color })
                                    }
                                />
                            </Stack>
                        )}

                        {activeStep === 2 && (
                            <Stack spacing={2}>
                                <Typography variant="subtitle1">
                                    {i18n.t('themeEditor.actionGradientsTitle')}
                                </Typography>

                                <GradientEditor
                                    colorStops={gradientColorsAction}
                                    onChange={(colorStops) =>
                                        this.setState({
                                            gradientColorsAction: colorStops
                                        })
                                    }
                                />
                                <Typography variant="subtitle1">
                                    {i18n.t('themeEditor.chooseColorAction')}
                                </Typography>

                                <ColorPicker
                                    color={colorAction}
                                    onChange={(color) =>
                                        this.setState({ colorAction: color })
                                    }
                                />
                            </Stack>
                        )}

                        <Divider sx={{ my: 2 }} />

                        <Box display="flex" justifyContent="space-between">
                            <Button
                                disabled={activeStep === 0}
                                onClick={this.handlePrevStep}
                            >
                                {i18n.t('buttons.prev')}
                            </Button>
                            <Button
                                disabled={activeStep === 2}
                                onClick={this.handleNextStep}
                            >
                                {i18n.t('buttons.next')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={this.handleClose}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button onClick={this.handleSave}>
                        {i18n.t('buttons.save')}
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }
}

export default ThemeEditorDialog;
